import React from 'react';
import { UserImg } from './styles';

export interface AvatarImageProps {
  className?: string;
  imageUrl: string;
  size: string;
}

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340650300074
 */
export const AvatarImage: React.FC<AvatarImageProps> = ({ className, imageUrl, size }) => (
  <UserImg className={className} src={imageUrl} size={size} />
);
